import React from 'react';
import { Header } from './Header';
import { Testimonial } from './Testimonial';
import { CallToAction } from './CallToAction';
import { CheckCircleIcon, ShieldIcon, AwardIcon, BookmarkIcon, FileTextIcon, ZapIcon } from 'lucide-react';
export const Advertorial = () => {
  return <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 font-serif bg-white border border-slate-200 shadow-sm" data-id="element-51">
      <Header data-id="element-52" />
      <main className="prose prose-slate max-w-none" data-id="element-53">
        <div className="flex items-center mb-6 border-b border-slate-200 pb-2" data-id="element-54">
          <FileTextIcon className="h-4 w-4 text-slate-600 mr-2" data-id="element-55" />
          <span className="text-xs uppercase tracking-wider text-slate-600 font-medium" data-id="element-56">
            Trending Article
          </span>
        </div>
        <div className="mb-8 mt-6" data-id="element-57">
          <p className="text-base sm:text-lg font-normal text-slate-900 leading-relaxed border-l-4 pl-4 border-slate-300 italic" data-id="element-58">
            If you've tried antibiotics, boric acid, probiotics, and every
            "miracle cure" for recurring BV and vaginal odor only to have
            symptoms return weeks later, you're not alone and it's not your
            fault.
          </p>
        </div>
        <p className="text-base text-slate-800 leading-relaxed mb-4" data-id="element-59">
          Leading gynecologist Dr. Grace Holland just published this new
          research proving that{' '}
          <span className="font-semibold text-slate-900 bg-yellow-100 px-1" data-id="element-60">
            73% of women with recurring vaginal issues never find lasting relief
          </span>{' '}
          because every treatment they've tried attacks the wrong target.
        </p>
        <p className="text-base text-slate-800 leading-relaxed mb-8" data-id="element-61">
          But more importantly, she discovered exactly what's protecting the bad
          bacteria and what finally breaks through.
        </p>
        <p className="text-base text-slate-800 leading-relaxed mb-8" data-id="element-62">
          And it has nothing to do with balancing good bacteria and bad
          bacteria, like everyone thought, it's much deeper.
        </p>
        <h2 className="text-2xl font-serif font-bold text-slate-900 mt-10 mb-5 leading-tight border-b border-slate-200 pb-2 flex items-center" data-id="element-63">
          <BookmarkIcon className="h-5 w-5 text-slate-700 mr-2 inline" data-id="element-64" />
          What's Actually Happening Inside Your Vaginal Microbiome
        </h2>
        <figure className="my-8 border border-slate-200" data-id="element-65">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/p9CjdyCWZXVxk86iLxCwDX/Screenshot_2025-09-20_at_11.21.22_AM.png" alt="Diagram of female reproductive system with magnified biofilm view" className="w-full h-auto object-cover" data-id="element-66" />
        </figure>
        <p className="text-base text-slate-800 leading-relaxed mb-3" data-id="element-67">
          Here's what's happening right now, at this very moment, inside your
          vagina:
        </p>
        <p className="text-base text-slate-800 leading-relaxed mb-6" data-id="element-68">
          Bad bacteria create three major problems that almost no treatment can
          overcome:
        </p>
        <div className="bg-white p-5 sm:p-6 rounded my-6 border-l-2 border-slate-700 shadow-sm" data-id="element-69">
          <h3 className="text-lg sm:text-xl font-serif font-semibold text-slate-900 mb-3" data-id="element-70">
            The Biofilm Shield
          </h3>
          <p className="text-base text-slate-700 leading-relaxed" data-id="element-71">
            Bad bacteria don't just multiply - they build an invisible, slimy
            protective layer around themselves called a{' '}
            <span className="bg-yellow-100 px-1" data-id="element-72">"biofilm."</span> So actually
            the antibiotics and probiotics you've tried can only kill the
            bacteria outside this shield, but the core of it stays protected
            inside, ready to come back the moment treatment stops.
          </p>
        </div>
        <div className="bg-white p-5 sm:p-6 rounded my-6 border-l-2 border-slate-700 shadow-sm" data-id="element-73">
          <h3 className="text-lg sm:text-xl font-serif font-semibold text-slate-900 mb-3" data-id="element-74">
            The Backup System
          </h3>
          <p className="text-base text-slate-700 leading-relaxed" data-id="element-75">
            Inside this protective layer, bad bacteria communicate and share
            resources. When antibiotics attack one area, bacteria from other
            areas quickly move in to replace them. It's like trying to clear
            weeds from a garden when the root system is still connected
            underground.
          </p>
        </div>
        <div className="bg-white p-5 sm:p-6 rounded my-6 border-l-2 border-slate-700 shadow-sm" data-id="element-76">
          <h3 className="text-lg sm:text-xl font-serif font-semibold text-slate-900 mb-3" data-id="element-77">
            The Comeback Strategy
          </h3>
          <p className="text-base text-slate-700 leading-relaxed" data-id="element-78">
            Even when treatments appear successful, biofilm bacteria enter a
            dormant state, waiting for optimal conditions to return.{' '}
            <span className="bg-yellow-100 px-1" data-id="element-79">
              Within days of stopping treatment, they reactivate at full
              strength
            </span>
            , producing the same odor and discharge.
          </p>
        </div>
        <div className="border-t border-b border-slate-300 py-5 my-8 text-center" data-id="element-80">
          <p className="text-lg font-serif text-slate-800" data-id="element-81">
            Dr. Holland calls this the{' '}
            <span className="bg-yellow-100 px-1" data-id="element-82">"Biofilm Time Bomb."</span>{' '}
            Your treatments are fighting an enemy that's literally hiding behind
            a shield.
          </p>
        </div>
        <blockquote className="italic pl-4 py-2 my-6 text-slate-700 leading-relaxed border-l-4 border-slate-400" data-id="element-83">
          "Every antibiotic, every probiotic hits the surface while the real
          problem stays safely protected underneath, ready to make everything
          dirty again."
        </blockquote>
        <h2 className="text-2xl font-serif font-bold text-slate-900 mt-10 mb-5 leading-tight border-b border-slate-200 pb-2" data-id="element-84">
          Why Nothing You've Tried Has Worked
        </h2>
        <figure className="my-8 border border-slate-200" data-id="element-85">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tqss61WUSv2UpeJoSaesty/Screenshot_2025-09-20_at_11.21.33_AM.png" alt="Supplement bottles and weekly pill organizer next to purple underwear with white discharge" className="w-full h-auto object-cover" data-id="element-86" />
        </figure>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 my-6 sm:my-8" data-id="element-87">
          <div className="bg-white p-4 sm:p-5 border border-slate-200" data-id="element-88">
            <p className="font-semibold text-slate-900 mb-2" data-id="element-89">
              If you've tried antibiotics...
            </p>
            <p className="text-base text-slate-700 leading-relaxed" data-id="element-90">
              They kill some bacteria on the surface but{' '}
              <span className="bg-yellow-100 px-1" data-id="element-91">
                the main core survives inside, ready to multiply again within
                just days.
              </span>
            </p>
          </div>
          <div className="bg-white p-4 sm:p-5 border border-slate-200" data-id="element-92">
            <p className="font-semibold text-slate-900 mb-2" data-id="element-93">
              If you've tried boric acid...
            </p>
            <p className="text-base text-slate-700 leading-relaxed" data-id="element-94">
              It temporarily improves your vaginal pH, but biofilm bacteria
              adapt to these changes and after a few days the protective barrier
              is still there, stronger than before.
            </p>
          </div>
          <div className="bg-white p-4 sm:p-5 border border-slate-200" data-id="element-95">
            <p className="font-semibold text-slate-900 mb-2" data-id="element-96">
              If you've tried regular probiotics...
            </p>
            <p className="text-base text-slate-700 leading-relaxed" data-id="element-97">
              <span className="bg-yellow-100 px-1" data-id="element-98">
                Most die before even reaching your vagina.
              </span>{' '}
              Even if they survive, they can't compete with the bad bacteria
              that already control the area.
            </p>
          </div>
          <div className="bg-white p-4 sm:p-5 border border-slate-200" data-id="element-99">
            <p className="font-semibold text-slate-900 mb-2" data-id="element-100">
              If you've tried "feminine washes"...
            </p>
            <p className="text-base text-slate-700 leading-relaxed" data-id="element-101">
              You're actually making it worse by killing your natural defenses,
              giving bad bacteria easier access.
            </p>
          </div>
        </div>
        <p className="text-base font-serif text-slate-900 leading-relaxed mb-6" data-id="element-102">
          These solutions fail because they can't break through the protective
          barrier.
        </p>
        <figure className="my-8 border border-slate-200" data-id="element-103">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ix5RgFrBdghUjphyoU3XTx/Screenshot_2025-09-20_at_11.21.41_AM.png" alt="Collage of various medications and supplements in bottles and bags" className="w-full h-auto object-cover" data-id="element-104" />
        </figure>
        <blockquote className="pl-4 py-2 my-6 text-slate-700 leading-relaxed border-l-4 border-slate-400" data-id="element-105">
          <p data-id="element-106">
            "I had patients taking antibiotics every month, using boric acid
            every night, spending $300+ on probiotics," Holland recalls.
          </p>
          <p className="mt-3" data-id="element-107">
            "Their symptoms kept coming back because{' '}
            <span className="bg-yellow-100 px-1" data-id="element-108">
              nothing was breaking through that protective layer.
            </span>{' '}
            We were treating the surface while the real cause stayed
            untouchable."
          </p>
        </blockquote>
        <h2 className="text-2xl font-serif font-bold text-slate-900 mt-10 mb-5 leading-tight border-b border-slate-200 pb-2" data-id="element-109">
          So This Simple Finding Changed Everything
        </h2>
        <p className="text-base text-slate-800 leading-relaxed mb-3" data-id="element-110">
          Holland studied 89 patients with recurring BV and vaginal odor.
        </p>
        <p className="text-base text-slate-800 leading-relaxed mb-3" data-id="element-111">
          All had tried multiple treatments.
        </p>
        <p className="text-base text-slate-800 leading-relaxed mb-6" data-id="element-112">
          All experienced the same cycle: temporary relief, then symptoms return
          stronger.
        </p>
        <figure className="my-8 border border-slate-200" data-id="element-113">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fEyxpcNtnTqPBtuaa1cWf3/Screenshot_2025-09-20_at_11.21.49_AM.png" alt="Woman in white top sitting and holding her lower abdomen" className="w-full h-auto object-cover" data-id="element-114" />
        </figure>
        <p className="text-base text-slate-800 leading-relaxed mb-5" data-id="element-115">
          But when she looked at the 16 patients who got better and stayed
          better, she found something amazing:
        </p>
        <div className="border-t border-b border-slate-300 py-5 my-6 sm:my-8" data-id="element-116">
          <p className="text-base sm:text-lg font-serif font-semibold text-slate-900 leading-relaxed" data-id="element-117">
            Every single woman who stayed healthy had one thing in common:{' '}
            <span className="bg-yellow-100 px-1" data-id="element-118">
              much higher levels of enzymes that could break down this biofilm.
            </span>
          </p>
        </div>
        <blockquote className="italic pl-4 py-2 my-6 text-slate-700 leading-relaxed border-l-4 border-slate-400" data-id="element-119">
          "It was so obvious once I saw it," Holland explains. "Women with
          healthy balance had way more of these barrier-breaking enzymes.
          Everyone stuck in the infection cycle had almost none."
        </blockquote>
        <figure className="my-8 border border-slate-200" data-id="element-120">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ivprU3HM9qWqXk4c79JdAa/Screenshot_2025-09-20_at_11.21.57_AM.png" alt="Illustrated diagram of female reproductive system with cartoon bacteria" className="w-full h-auto object-cover" data-id="element-121" />
        </figure>
        <p className="text-base text-slate-800 leading-relaxed mb-3" data-id="element-122">
          But here's what took 2 years to figure out: it's not just about these
          enzymes...
        </p>
        <p className="text-base text-slate-800 leading-relaxed mb-6" data-id="element-123">
          You need to solve THREE problems at once with what Holland calls the
          <span className="bg-yellow-100 px-1" data-id="element-124">"Triple-Fix System"</span>:
        </p>
        <div className="bg-slate-100 p-5 sm:p-8 my-8" data-id="element-125">
          <div className="flex items-start mb-6" data-id="element-126">
            <span className="font-serif text-slate-700 font-bold text-2xl mr-4 mt-1" data-id="element-127">
              1.
            </span>
            <div data-id="element-128">
              <p className="font-serif font-semibold text-slate-900 text-lg mb-1" data-id="element-129">
                BREAK
              </p>
              <p className="text-base text-slate-700 leading-relaxed" data-id="element-130">
                Dissolve the protective barrier around bad bacteria
              </p>
            </div>
          </div>
          <div className="flex items-start mb-6" data-id="element-131">
            <span className="font-serif text-slate-700 font-bold text-2xl mr-4 mt-1" data-id="element-132">
              2.
            </span>
            <div data-id="element-133">
              <p className="font-serif font-semibold text-slate-900 text-lg mb-1" data-id="element-134">
                BALANCE
              </p>
              <p className="text-base text-slate-700 leading-relaxed" data-id="element-135">
                Add probiotics, but only those which can actually survive and
                take over
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-136">
            <span className="font-serif text-slate-700 font-bold text-2xl mr-4 mt-1" data-id="element-137">
              3.
            </span>
            <div data-id="element-138">
              <p className="font-serif font-semibold text-slate-900 text-lg mb-1" data-id="element-139">
                BLOCK
              </p>
              <p className="text-base text-slate-700 leading-relaxed" data-id="element-140">
                Prevent the barrier from forming again
              </p>
            </div>
          </div>
        </div>
        <blockquote className="italic pl-4 py-2 my-6 text-slate-700 leading-relaxed border-l-4 border-slate-400" data-id="element-141">
          "It's simple," Holland explains.{' '}
          <span className="bg-yellow-100 px-1" data-id="element-142">
            "BREAK the shield, BALANCE with the right probiotics, and BLOCK it
            from coming back.
          </span>{' '}
          You need only 3 steps for a real result."
        </blockquote>
        <h2 className="text-2xl font-serif font-bold text-slate-900 mt-10 mb-5 leading-tight border-b border-slate-200 pb-2" data-id="element-143">
          The Pineapple Secret That Solved Everything
        </h2>
        <p className="text-base text-slate-800 leading-relaxed mb-6" data-id="element-144">
          The answer came from somewhere unexpected. Holland's research partner
          from Germany was studying fruit enzymes when she discovered something
          incredible:
        </p>
        <figure className="my-8 border border-slate-200" data-id="element-145">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ti6ibCs2TqUpsr4idpu7qj/Screenshot_2025-09-20_at_11.22.07_AM.png" alt="Two female scientists in lab coats examining data on a tablet" className="w-full h-auto object-cover" data-id="element-146" />
        </figure>
        <div className="border-t border-b border-slate-300 py-5 my-8 text-center" data-id="element-147">
          <p className="text-lg font-serif text-slate-800" data-id="element-148">
            <span className="bg-yellow-100 px-1" data-id="element-149">
              Pineapple enzymes could dissolve these protective barriers by
              80-95%.
            </span>
          </p>
        </div>
        <blockquote className="italic pl-4 py-2 my-6 text-slate-700 leading-relaxed border-l-4 border-slate-400" data-id="element-150">
          "We'd been trying to kill bacteria when the answer was breaking down
          their shield," Holland explains. "Pineapple enzymes don't fight
          bacteria - they just remove their protection, leaving them
          defenseless."
        </blockquote>
        <p className="text-base text-slate-800 leading-relaxed mb-4" data-id="element-151">
          But here's the problem: you'd need to eat pounds of pineapples every
          day to get enough enzymes. And{' '}
          <span className="bg-yellow-100 px-1" data-id="element-152">
            most of the powerful enzymes are in the stem, not the fruit.
          </span>{' '}
          But every single product out there has been pushing the fruit part.
        </p>
        <p className="text-base text-slate-800 leading-relaxed mb-4" data-id="element-153">
          This led to Holland's next breakthrough: special probiotics that can
          actually survive.
        </p>
        <p className="text-base text-slate-800 leading-relaxed mb-4" data-id="element-154">
          Unlike regular probiotics that die in your stomach,{' '}
          <span className="bg-yellow-100 px-1" data-id="element-155">
            these create their own protective shells.
          </span>{' '}
          They survive the trip and are ready to take over once the bad bacteria
          lose their shield.
        </p>
        <p className="text-base text-slate-800 leading-relaxed mb-4" data-id="element-156">
          After trying 52 different combinations that didn't work...
        </p>
        <div className="border-t border-b border-slate-300 py-5 my-8 text-center" data-id="element-157">
          <p className="text-lg font-serif text-slate-800" data-id="element-158">
            She discovered that{' '}
            <span className="bg-yellow-100 px-1" data-id="element-159">
              gummy vitamins could deliver everything perfectly.
            </span>
          </p>
        </div>
        <p className="text-base text-slate-800 leading-relaxed mb-8" data-id="element-160">
          The gummy form protects the enzymes and makes them easy and safe to
          deliver to your gut.
        </p>

        <figure className="my-8 border border-slate-200" data-id="element-161">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/g1yRFCbdsfjUxW7NVSLWe2/Screenshot_2025-09-20_at_11.22.29_AM.png" alt="Customer review of Nuora Feminine Balance Gummies showing 5-star rating" className="w-full h-auto object-cover" data-id="element-162" />
        </figure>
        <Testimonial quote="After 6 years of struggling with BV and bad breath without success, this product finally worked and completely changed my life" name="Caroline K." description="41-year-old teacher, had recurring BV for 6 years. She'd tried 5 rounds of antibiotics, boric acid every night, and every probiotic on Amazon." data-id="element-163" />
        <div className="bg-white p-6 my-8 border border-slate-200" data-id="element-164">
          <h3 className="text-lg sm:text-xl font-serif font-semibold text-slate-900 mb-5 border-b border-slate-100 pb-2" data-id="element-165">
            What Women Report When Taking Nuora
          </h3>
          <div className="space-y-5" data-id="element-166">
            <div className="bg-slate-50 p-4 rounded border-l-4 border-blue-500" data-id="element-167">
              <h4 className="font-serif text-slate-900 font-semibold mb-2" data-id="element-168">
                Days 3-5
              </h4>
              <p className="text-slate-700 leading-relaxed" data-id="element-169">
                Discharge starts clearing. Odor fading noticeably. Less panic
                checking throughout the day.
              </p>
            </div>
            <div className="bg-slate-50 p-4 rounded border-l-4 border-green-500" data-id="element-170">
              <h4 className="font-serif text-slate-900 font-semibold mb-2" data-id="element-171">
                Week 1-2
              </h4>
              <p className="text-slate-700 leading-relaxed" data-id="element-172">
                Clear improvement. pH stabilizing. Waking up without that "can
                anyone smell me?" anxiety. Normal discharge returning.
              </p>
            </div>
            <div className="bg-slate-50 p-4 rounded border-l-4 border-purple-500" data-id="element-173">
              <h4 className="font-serif text-slate-900 font-semibold mb-2" data-id="element-174">
                Week 3-4
              </h4>
              <p className="text-slate-700 leading-relaxed" data-id="element-175">
                Major shift. No more avoiding intimacy. Tests coming back
                normal. Feeling like yourself again.
              </p>
            </div>
            <div className="bg-slate-50 p-4 rounded border-l-4 border-orange-500" data-id="element-176">
              <h4 className="font-serif text-slate-900 font-semibold mb-2" data-id="element-177">
                Month 2+
              </h4>
              <p className="text-slate-700 leading-relaxed" data-id="element-178">
                Sustained results. No recurrence. Infections aren't coming back
                every 2-3 months. Complete freedom from the antibiotic cycle.
              </p>
            </div>
            <div className="bg-yellow-50 p-4 rounded border border-yellow-200 flex items-start" data-id="element-179">
              <div className="bg-amber-100 rounded-lg p-2 mr-3 flex-shrink-0" data-id="element-180">
                <ZapIcon className="h-5 w-5 text-amber-600" data-id="element-181" />
              </div>
              <p className="text-slate-800 leading-relaxed" data-id="element-182">
                <strong data-id="element-183">
                  The difference between this working and not working is
                  clearing the biofilm and the simultaneous delivery of good
                  bacteria to the vaginal walls.
                </strong>
                <br data-id="element-184" />
                <br data-id="element-185" />
                Without breaking down that protective barrier first, probiotics
                can't colonize and you stay stuck in temporary relief followed
                by symptoms returning.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 my-8" data-id="element-186">
          <div className="bg-white p-5 text-center border border-slate-200" data-id="element-187">
            <p className="text-3xl font-serif font-bold text-slate-900 mb-2" data-id="element-188">
              87%
            </p>
            <p className="text-base text-slate-700" data-id="element-189">
              experience{' '}
              <span className="bg-yellow-100 px-1" data-id="element-190">
                reduced odor and discharge within 7 days
              </span>
            </p>
          </div>
          <div className="bg-white p-5 text-center border border-slate-200" data-id="element-191">
            <p className="text-3xl font-serif font-bold text-slate-900 mb-2" data-id="element-192">
              91%
            </p>
            <p className="text-base text-slate-700" data-id="element-193">
              achieve clear test results by week 4
            </p>
          </div>
          <div className="bg-white p-5 text-center border border-slate-200" data-id="element-194">
            <p className="text-3xl font-serif font-bold text-slate-900 mb-2" data-id="element-195">
              93%
            </p>
            <p className="text-base text-slate-700" data-id="element-196">
              <span className="bg-yellow-100 px-1" data-id="element-197">
                remain completely symptom-free at 6-month follow-up
              </span>
            </p>
          </div>
        </div>
        <Testimonial quote="Two years of recurring BV, thousands spent on treatments. Nothing worked until I destroyed the biofilms. I haven't had this odor in 9 months." name="Sarah L." description="35" data-id="element-198" />
        <h2 className="text-2xl font-serif font-bold text-slate-900 mt-10 mb-5 leading-tight border-b border-slate-200 pb-2" data-id="element-199">
          Nuora Is The First Solution For The Biofilm Problem
        </h2>

        <figure className="my-8 border border-slate-200" data-id="element-200">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hn6boXibDv6iJ4r71hmj2E/Screenshot_2025-09-20_at_2.13.34_PM.png" alt="Collage of women holding Nuora product packages and gummies" className="w-full h-auto object-cover" data-id="element-201" />
        </figure>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 my-8" data-id="element-202"></div>
        <Testimonial quote="I feel sexy, clean, and confident again. My husband and I are closer than we've been in the last 7 years. I'm not avoiding intimacy anymore, and I don't have to worry about the smell. For the first time in years, my husband actually said I taste sweet…" name="Jennifer R." data-id="element-203" />

        <div className="bg-slate-50 p-6 my-8" data-id="element-204">
          <div className="flex items-start mb-4" data-id="element-205">
            <ShieldIcon className="h-6 w-6 text-slate-700 mr-3 mt-1 flex-shrink-0" data-id="element-206" />
            <h3 className="text-lg sm:text-xl font-serif font-semibold text-slate-900" data-id="element-207">
              What you're actually getting with Nuora
            </h3>
          </div>
          <p className="text-base text-slate-700 mb-6" data-id="element-208">
            Take 2 gummies each day.
          </p>
          <h4 className="font-semibold text-slate-900 mb-4" data-id="element-209">Contains:</h4>
          <ul className="space-y-4" data-id="element-210">
            <li className="flex items-start" data-id="element-211">
              <CheckCircleIcon className="h-5 w-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-212" />
              <div data-id="element-213">
                <span className="font-semibold text-slate-900" data-id="element-214">
                  Bacillus Coagulans 1969
                </span>
                <span className="text-slate-700" data-id="element-215">
                  {' '}
                  - Spore-forming probiotic that survives your digestive system
                  and reaches vaginal tissue alive
                </span>
              </div>
            </li>
            <li className="flex items-start" data-id="element-216">
              <CheckCircleIcon className="h-5 w-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-217" />
              <div data-id="element-218">
                <span className="font-semibold text-slate-900" data-id="element-219">
                  Organic Pineapple Extract
                </span>
                <span className="text-slate-700" data-id="element-220">
                  {' '}
                  - Breaks down biofilm by 80-95% creating the foundation for
                  our good bacteria to get to work
                </span>
              </div>
            </li>
            <li className="flex items-start" data-id="element-221">
              <CheckCircleIcon className="h-5 w-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-222" />
              <div data-id="element-223">
                <span className="font-semibold text-slate-900" data-id="element-224">Vitamin C</span>
                <span className="text-slate-700" data-id="element-225">
                  {' '}
                  - Strengthens tissue and boosts probiotic absorption by 53%
                </span>
              </div>
            </li>
            <li className="flex items-start" data-id="element-226">
              <CheckCircleIcon className="h-5 w-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-227" />
              <div data-id="element-228">
                <span className="font-semibold text-slate-900" data-id="element-229">
                  Prebiotic Fiber
                </span>
                <span className="text-slate-700" data-id="element-230">
                  {' '}
                  - Feeds good bacteria while starving the bad ones
                </span>
              </div>
            </li>
          </ul>
          <div className="mt-6 pt-4 border-t border-slate-100" data-id="element-231">
            <div className="bg-slate-900 text-white text-center py-3 px-4 rounded-md" data-id="element-232">
              <span className="font-medium" data-id="element-233">One package = 30-day supply.</span>
            </div>
          </div>
        </div>
        
        <p className="text-base text-slate-800 leading-relaxed mb-2" data-id="element-234">
          She tried having patients take everything separately:
        </p>
        <p className="text-base text-slate-800 leading-relaxed mb-6" data-id="element-235">
          It required 3 different supplements, perfect timing all day, and cost
          over $140 monthly. Almost no one could stick with it and results were
          inconsistent.
        </p>
        <blockquote className="italic pl-4 py-2 my-6 text-slate-700 leading-relaxed border-l-4 border-slate-400" data-id="element-236">
          "Nuora works because it contains{' '}
          <span className="bg-yellow-100 px-1" data-id="element-237">
            real enzymes and everything is precisely timed to work together
          </span>
          " Holland says.
        </blockquote>
        
        
        <figure className="my-8 border border-slate-200" data-id="element-238"></figure>
        

        <div className="my-8" data-id="element-239">
          <div className="flex items-center mb-4" data-id="element-240">
            <ShieldIcon className="h-5 w-5 text-slate-700 mr-2" data-id="element-241" />
            <h3 className="text-xl font-serif font-bold text-slate-900" data-id="element-242">
              Risk-free for 60 days
            </h3>
          </div>
          <div className="bg-green-50 border-l-4 border-green-500 p-5 mb-6" data-id="element-243">
            <div className="flex items-start" data-id="element-244">
              <CheckCircleIcon className="h-5 w-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-245" />
              <div data-id="element-246">
                <p className="font-semibold text-slate-900 mb-2" data-id="element-247">
                  Try it for a full month
                </p>
                <p className="text-slate-700 leading-relaxed" data-id="element-248">
                  If your bv doesn't improve, if your discharge doesn't return
                  to normal, if you don't have odor disappear - get every penny
                  back with one single email.
                </p>
              </div>
            </div>
          </div>
          <p className="text-base text-slate-800 leading-relaxed mb-8" data-id="element-249">
            The only way you lose here is by staying in the flagyl and
            antibiotic cycle
          </p>
        </div>
        <div className="my-8 border-t border-slate-200 pt-8" data-id="element-250">
          <div className="flex items-center mb-4" data-id="element-251">
            <ZapIcon className="h-5 w-5 text-slate-700 mr-2" data-id="element-252" />
            <h3 className="text-xl font-serif font-bold text-slate-900" data-id="element-253">
              Why this keeps selling out
            </h3>
          </div>
          <div className="bg-red-50 border-l-4 border-red-500 p-5" data-id="element-254">
            <div className="flex items-start" data-id="element-255">
              <div className="bg-red-100 rounded-full p-1 mr-3 mt-0.5 flex-shrink-0" data-id="element-256">
                <svg className="h-4 w-4 text-red-600" fill="currentColor" viewBox="0 0 20 20" data-id="element-257">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-258" />
                </svg>
              </div>
              <div data-id="element-259">
                <p className="font-semibold text-slate-900 mb-2" data-id="element-260">
                  Because of these videos, we keep running low on stock.
                </p>
                <p className="text-slate-700 leading-relaxed mb-2" data-id="element-261">
                  If you can see the order button below, we have inventory now.
                </p>
                <p className="text-slate-700 leading-relaxed" data-id="element-262">
                  But last month we sold out for 11 days because production
                  couldn't keep up.
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <CallToAction destinationUrl="https://mynuora.com/products/feminine-balance-gummies-1" buttonText="CHECK IF AVAILABLE" productName="BV Treatment Interest" descriptionText="Get guaranteed access to the recent batch below" data-id="element-263" />
        <p className="text-xs text-slate-500 mt-5 text-center border-t border-slate-200 pt-4" data-id="element-264">
          Note: This special access is only for readers of this article. The
          link stops working when this batch sells out or after 48 hours.
        </p>
      </main>
    </div>;
};